/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-datalabels-display',
  templateUrl: './theme-option-datalabels-display.component.html',
  styleUrls: ['./theme-option-datalabels-display.component.css']
})
export class ThemeOptionDatalabelsDisplayComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() datalabelsIndex: number;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'datalabels_display';
  showDetails: boolean;

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: string, type?: ChartType) {
    this.themeOptions.setDatalabels(this.optionType, value === 'true' ? true : value === 'false' ? false : value, this.datalabelsIndex, type ? [type] : undefined);
  }

  values = {
    true: { icon: 'check-square far', style: 'true', label: 'TO_DISPLAY' },
    auto: { icon: 'bring-forward fas', style: 'auto', label: 'AUTO' },
    false: { icon: 'times-square far', style: 'false', label: 'HIDE' },
  };

}
